import type { ReactNode } from 'react';
import Modal from '@/components/base/Modal';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  tone?: 'danger' | 'cta' | 'primary';
  onConfirm: () => void;
  onClose: () => void;
}

const toneClasses = {
  danger: 'bg-danger-500 text-white hover:bg-danger-600',
  cta: 'bg-secondary-500 text-white hover:bg-secondary-600',
  primary: 'bg-primary-500 text-white hover:bg-primary-600',
};

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'تأكيد',
  cancelLabel = 'إلغاء',
  tone = 'danger',
  onConfirm,
  onClose,
}: ConfirmDialogProps) {
  return (
    <Modal open={open} title={title} onClose={onClose} maxWidth="max-w-[420px]">
      <div className="text-sm leading-relaxed text-foreground-600">{message}</div>
      <div className="mt-6 flex items-center gap-3">
        <button
          type="button"
          onClick={onClose}
          className="h-11 flex-1 rounded-btn border border-background-300 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-50"
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          className={`h-11 flex-1 rounded-btn text-sm font-semibold transition-colors ${toneClasses[tone]}`}
        >
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}